var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessMatchAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 437,
    viewBox: "0 0 292 437",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.6 0C65.69 0 0 62.312 0 151.2C0 182.919 7.4727 204.985 21.352 229.427L135.802 431.027V431.023C137.775 434.59 141.529 436.8 145.603 436.8C149.677 436.8 153.431 434.59 155.404 431.023L269.854 229.423C283.733 204.985 291.206 182.919 291.206 151.2C291.206 62.3131 225.515 9.15527e-05 145.606 9.15527e-05L145.6 0ZM145.6 78.398C182.713 78.398 212.799 108.484 212.799 145.597C212.799 182.71 182.713 212.796 145.6 212.796C108.487 212.796 78.401 182.71 78.401 145.597C78.401 108.484 108.487 78.398 145.6 78.398Z",
    fill: "#0A9607"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMatchAddress);
export default __webpack_public_path__ + "static/media/success_match_address.8a20a351fddcd9ac74ad499ca20e8774.svg";
export { ForwardRef as ReactComponent };